import { useEffect } from "react";
import { Zap } from "lucide-react";

type Props = {
  fromName: string;
  mine: boolean;
  discreet: boolean;
  onDone: () => void;
};

export function ChatAurizOverlay({ fromName, mine, discreet, onDone }: Props) {
  useEffect(() => {
    const t = window.setTimeout(onDone, discreet ? 1700 : 1900);
    return () => window.clearTimeout(t);
  }, [onDone]);

  const label = mine ? "Auriz envoyé" : `${fromName} t’envoie un Auriz`;

  if (discreet) {
    return (
      <div className="chat-auriz-toast" role="status">
        <Zap className="size-3.5" strokeWidth={2.4} />
        {label}
      </div>
    );
  }

  return (
    <div className="chat-auriz-overlay" role="status" aria-live="polite">
      <div className="chat-auriz-overlay__rings" aria-hidden>
        <span />
        <span />
        <span />
      </div>
      <div className="chat-auriz-overlay__sparks" aria-hidden>
        {Array.from({ length: 10 }, (_, i) => (
          <i key={i} />
        ))}
      </div>
      <div className="chat-auriz-overlay__badge">
        <Zap className="chat-auriz-overlay__zap" strokeWidth={2.4} />
        <strong>Auriz</strong>
        <em>{mine ? "envoyé" : `de ${fromName}`}</em>
      </div>
    </div>
  );
}
